module.exports = __webpack_public_path__ + "media/images/athletes/2787-0bc6af8ebb7468122df9af160697722c.png";